import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {UtilService} from '../../../services/util.service';
import {SizeElasticityReport} from '../../../models/size-elasticity-report.model';
import {SizeElasticityService} from '../../../services/size-elasticity.service';
import {UiBlockerService} from '../../../services/ui-blocker.service';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SizeElasticityResolver implements Resolve<Observable<Array<SizeElasticityReport>>> {

  constructor(private service: SizeElasticityService, private utilService: UtilService, private uiBlockerService: UiBlockerService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<SizeElasticityReport>> {
    this.uiBlockerService.block();
    const projectId = this.utilService.getRouteParameter(route, 'projectId');
    const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
    return this.service.fetchAll(+projectId, modelRunId).pipe(map((reports: SizeElasticityReport[]) => {
      this.uiBlockerService.unblock();
      return reports;
    }));
  }
}
